// Moment of Inertia units with conversion factors to kilogram square meter (kg·m²)
export const momentOfInertiaUnits = [
  { id: 'kilogram-square-meter', name: 'Kilogram Square Meter', symbol: 'kg·m²', plural: 'Kilogram Square Meters', factor: 1 },
  { id: 'kilogram-square-centimeter', name: 'Kilogram Square Centimeter', symbol: 'kg·cm²', plural: 'Kilogram Square Centimeters', factor: 0.0001 },
  { id: 'kilogram-square-millimeter', name: 'Kilogram Square Millimeter', symbol: 'kg·mm²', plural: 'Kilogram Square Millimeters', factor: 0.000001 },
  { id: 'gram-square-meter', name: 'Gram Square Meter', symbol: 'g·m²', plural: 'Gram Square Meters', factor: 0.001 },
  { id: 'gram-square-centimeter', name: 'Gram Square Centimeter', symbol: 'g·cm²', plural: 'Gram Square Centimeters', factor: 0.0000001 },
  { id: 'gram-square-millimeter', name: 'Gram Square Millimeter', symbol: 'g·mm²', plural: 'Gram Square Millimeters', factor: 0.000000001 },
  { id: 'kilogram-force-meter-square-second', name: 'Kilogram-force Meter Second²', symbol: 'kgf·m·s²', plural: 'Kilogram-force Meter Second²', factor: 9.80665 },
  { id: 'kilogram-force-centimeter-square-second', name: 'Kilogram-force Centimeter Second²', symbol: 'kgf·cm·s²', plural: 'Kilogram-force Centimeter Second²', factor: 0.0980665 },
  { id: 'ounce-square-inch', name: 'Ounce Square Inch', symbol: 'oz·in²', plural: 'Ounce Square Inches', factor: 0.00001829007 },
  { id: 'pound-square-foot', name: 'Pound Square Foot', symbol: 'lb·ft²', plural: 'Pound Square Feet', factor: 0.04214011 },
  { id: 'pound-square-inch', name: 'Pound Square Inch', symbol: 'lb·in²', plural: 'Pound Square Inches', factor: 0.00029264 },
  { id: 'slug-square-foot', name: 'Slug Square Foot', symbol: 'slug·ft²', plural: 'Slug Square Feet', factor: 1.3558179 },
];

export const popularMomentOfInertiaConversions = [
  { from: 'kilogram-square-meter', to: 'pound-square-foot' },
  { from: 'pound-square-foot', to: 'kilogram-square-meter' },
  { from: 'kilogram-square-centimeter', to: 'kilogram-square-meter' },
  { from: 'gram-square-centimeter', to: 'kilogram-square-meter' },
  { from: 'pound-square-inch', to: 'kilogram-square-centimeter' },
  { from: 'slug-square-foot', to: 'kilogram-square-meter' },
];

export const getUnitById = (id) => momentOfInertiaUnits.find(unit => unit.id === id);

export const convertMomentOfInertia = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
